import React from "react";
import { Button, Table } from "antd";
import { formatPrice } from "../utils/utils";

interface Trade {
  _id: string;
  symbol: string;
  quantity: number;
  entryPrice: number;
  target: number;
  stopLoss: number;
  status: string;
  pnl: number;
}

interface TradesTableProps {
  trades: Trade[];
  closeTrade: (tradeId: string) => void;
}

const TradesTable: React.FC<TradesTableProps> = ({ trades, closeTrade }) => {
  const columns = [
    {
      title: "Symbol",
      dataIndex: "symbol",
      key: "symbol",
    },
    {
      title: "Quantity",
      dataIndex: "quantity",
      key: "quantity",
    },
    {
      title: "Entry Price",
      dataIndex: "entryPrice",
      key: "entryPrice",
      render: (price: number) => formatPrice(price),
    },
    {
      title: "Target",
      dataIndex: "target",
      key: "target",
      render: (price: number) => formatPrice(price),
    },
    {
      title: "Stop Loss",
      dataIndex: "stopLoss",
      key: "stopLoss",
      render: (price: number) => formatPrice(price),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
    },
    {
      title: "PnL",
      dataIndex: "pnl",
      key: "pnl",
      render: (pnl: number) => (
        <span style={{ color: pnl >= 0 ? "green" : "red" }}>
          {formatPrice(pnl)}
        </span>
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (_: any, record: Trade) => (
        <Button
          danger
          onClick={() => closeTrade(record._id)}
          disabled={record.status !== "OPEN"}
        >
          Close Trade
        </Button>
      ),
    },
  ];

  return (
    <div style={{ padding: "20px" }}>
      <h2>Trades</h2>
      <Table
        rowKey="_id"
        columns={columns}
        dataSource={trades}
        pagination={{ pageSize: 10 }}
        bordered
      />
    </div>
  );
};

export default TradesTable;
